/**
 * ChatMap edge type registry — passed to ReactFlow via the edgeTypes prop.
 * Adding a new edge type:
 *   1. Implement EdgeProps<TData> in a sibling file
 *   2. Register the key here matching the edges[i].type string the data
 *      processor emits
 */
import { ReferenceEdge } from './ReferenceEdge';
import { ForkEdge } from './ForkEdge';
import { MergeEdge } from './MergeEdge';
import { ReconsiderEdge } from './ReconsiderEdge';
export { ReferenceEdge, ForkEdge, MergeEdge, ReconsiderEdge };

export const chatDagEdgeTypes = {
  reference: ReferenceEdge,
  fork: ForkEdge,
  merge: MergeEdge,
  reconsider: ReconsiderEdge,
} as const;
